(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackCampaignsController', WinbackCampaignsController);

    WinbackCampaignsController.$inject = ['$state',];

    function WinbackCampaignsController($state) {
        // var vm = this;

        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'winbackCampaigns') {
                $state.go('winbackCampaigns.list');
            }
        }
    }
})();